import store from "@/store";

const getBranchNameById = (branchId) => {
  // Get branch list from Vuex
  const branches = store.getters.branches;

  // Find branch
  let branch = branches.find((branch) => branch.id === branchId);

  // Return '-' if branchName not match
  return branch !== undefined ? branch.name : "-";
};

export { getBranchNameById };
